// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"21534ad1","455":"a4b70b23","977":"d2b9499d"}[chunkId] + ".chunk.js";
};